const stateMap = {
  usa: [],
  north: ["NH", "MA", "CT", "RI", "MD", "VT", "NJ", "DE", "DC"],
  midWest: ["MN", "WI", "MI", "IA", "IL", "IN", "OH", "MO", "KY", "WV"],
  plains: ["MT", "ND", "WY", "SD", "CO", "NE", "KS", "OK", "NM", "TX", "AR"],
  south: ["VA", "TN", "NC", "LA", "MS", "AL", "GA", "SC", "FL"],
  west: ["WA", "OR", "ID", "CA", "NV", "UT", "AZ"],
  other: ["AK"],
};


export default stateMap;



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RegionSelect/stateMap.js